<template>
    <div class="container is-fluid">
        <div class="section">
            <div class="tile is-ancestor app-block section">
                <div class="tile is-vertical is-12">
                    <div class="tile">
                        <div class="tile is-parent is-6 has-vertically-aligned-content">
                            <article class="tile is-child">
                                <figure>
                                    <img :src="'/img/logos/eschool.png'" alt="Logo" class="school-logo">
                                </figure>
                            </article>
                        </div>
                    </div>

                    <!--<div class="app-block section box has-text-centered">
                        <router-link class="" :to="{ path: '/admissioneschool/eschool'}">
                            <h3 class="title is-3 has-text-weight-light">
                                <span>Nos formations : de la 6ème au bac +5</span>
                            </h3>
                        </router-link>


                    </div>

                    <div class="app-block section box has-text-centered">
                        <router-link class="title logo has-text-weight-light" :to="{ path: '/admissioneschool/eschool/offres/sessions'}">

                            <h3 class="title is-3 has-text-weight-light">
                                <span>Programmes à la carte</span>
                            </h3>
                        </router-link>

                    </div>-->

                    <div class="tile">
                        <div class="tile is-parent is-vertical">
                            <article class="tile is-child app-block">
                                <div class="card-image" id="france">
                                    <router-link class="has-text-white"
                                                 :to="{ path: '/admissioneschool/eschool'}">
                                        <transition name="component-fade" mode="out-in">
                                            <figure class="image is-3by1 m-b-none">
                                                <img :src="randomImage('e-school')" alt="">
                                            </figure>
                                        </transition>
                                        <div class="is-overlay is-clipped">
                                            <h2 class="card-footer-item title is-3 has-text-white has-text-weight-light is-primary-opacity">
                                                Nos formations : de la 6ème au bac +5
                                            </h2>
                                        </div>
                                    </router-link>
                                </div>

                            </article>
                            <article class="tile is-child app-block" v-if="categories.length > 0">
                                <div class="card-image">
                                    <router-link class="has-text-white"
                                                 :to="{ path: '/admissioneschool/eschool/offres/sessions'}">
                                        <transition name="component-fade" mode="out-in">
                                            <figure class="image is-3by1 m-b-none">
                                                <img :src="randomInternship(3)" alt="">
                                            </figure>
                                        </transition>
                                        <div class="is-overlay is-clipped">
                                            <h2 class="card-footer-item title is-3 has-text-white has-text-weight-light is-primary-opacity">
                                                Programmes à la carte
                                            </h2>
                                        </div>
                                    </router-link>
                                </div>
                            </article>
                        </div>

                    </div>

                    <!--<div class="tile">
                        <div class="tile is-parent is-vertical">
                            <article class="tile is-child app-block">
                                <div class="card-image" id="eschool">
                                    <router-link class="has-text-white"
                                                 :to="{ path: '/admissioneschool/eschool'}">
                                        <transition name="component-fade" mode="out-in">
                                            <figure class="image is-3by1 m-b-none">
                                                <img :src="'/img/logos/eschool.png'" alt="">
                                            </figure>
                                        </transition>
                                        <div class="is-overlay is-clipped">
                                            <h2 class="card-footer-item title is-3 has-text-white has-text-weight-light is-primary-opacity">
                                                Nos formations : de la 6ème au bac +5
                                            </h2>
                                        </div>
                                    </router-link>
                                </div>

                            </article>
                            <article class="tile is-child app-block" v-if="categories.length > 0">
                                <div class="card-image">
                                    <router-link class="has-text-white"
                                                 :to="{ path: '/admissioneschool/eschool/offres/sessions'}">
                                        <transition name="component-fade" mode="out-in">
                                            <figure class="image is-3by1 m-b-none">
                                                <img :src="randomInternship(5)" alt="">
                                            </figure>
                                        </transition>
                                        <div class="is-overlay is-clipped">
                                            <h2 class="card-footer-item title is-3 has-text-white has-text-weight-light is-primary-opacity">
                                                Programmes à la carte
                                            </h2>
                                        </div>
                                    </router-link>
                                </div>
                            </article>
                        </div>

                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import organization from 'services/organization'
    import offers from 'services/offers'
    import {mapGetters} from 'vuex'
    import ContactForm from '../../../offers/components/ContactForm'

    export default {
        data () {
            return {
                categories: [],
                contactForm: ContactForm,
                displayForm: true,
            }
        },
        computed: {
            ...mapGetters('organization', [
                'getSchoolBySlug'
            ])
        },
        methods: {
            sentMessage() {
                this.displayForm = false
                this.$scrollTo('.contact-form', {offset: 0})
            },
            randomImage (slug) {
                const school = this.getSchoolBySlug(slug)

                if (school) {
                    let campus = school.campuses[ Math.floor(Math.random() * school.campuses.length) ];
                    if (campus) {
                        return '/img/campus/' + campus.image
                    }
                }
            },
            randomInternship (category_id) {
                let category = this.categories.filter(function (cat) {
                    return cat.id === category_id
                })[0]

                if (category && category.offers && category.offers.length) {

                    let offer = category.offers[Math.floor(Math.random()*category.offers.length)];
                    if (offer && offer.medias.length) {
                        let image = offer.medias[Math.floor(Math.random()*offer.medias.length)];
                        return '/img/offers/'+image.path
                    }
                }


            },
            schoolLogo () {
                if (this.school) {
                    return this.$route.params.school + '.png'
                } else {
                    return 'diderot-logo.png'
                }
            },
        },
        created () {
            offers.offerCategories().then((result) => {
                this.categories = result.data
            }).catch(e => {
            })
            if (this.$route.hash === '#contact-form') {
                setTimeout(() => {
                    this.$scrollTo('.contact-form', { offset: 0 }, 500)
                }, 300)
            }

        }
    }
</script>
<style scoped>
    img {
        object-fit: cover;
    }
    .school-logo {
        max-width: 21em;
    }
    .school-border {
        border: 2px solid #0f1e44;
    }
</style>
